import { useRemoveManualDiscount } from 'src/composables/order/redemptions/discounts/RemoveManualDiscount'
import { ORDER_ITEM_STATES } from 'src/models/order-item/OrderItem'
import { VOUCHER_TYPE_TYPES } from 'src/models/voucher/VoucherType'
import { toValue } from 'vue'

export function useRemoveOrderItem () {
  const { removeManualDiscount } = useRemoveManualDiscount()

  function removeOrderItem (orderItemToRemove) {
    const orderItemToRemoveValue = toValue(orderItemToRemove)

    if (orderItemToRemoveValue.state !== ORDER_ITEM_STATES.DRAFT) return

    const order = orderItemToRemoveValue.order
    if (_.isNil(order)) {
      orderItemToRemoveValue.destroy()
      return
    }

    if (_.includes([VOUCHER_TYPE_TYPES.SPECIFIC_ITEM, VOUCHER_TYPE_TYPES.ITEM_PACKAGE], orderItemToRemoveValue.localVoucher?.voucherType?.type)) {
      orderItemToRemoveValue.localVoucher.autoApply = false
    }

    if (orderItemToRemoveValue.manualDiscount && !_.isNil(orderItemToRemoveValue.discountGroupKey)) {
      removeManualDiscount(orderItemToRemoveValue)
    }

    if (!_.isNil(orderItemToRemoveValue.itemPackage)) {
      const itemPackage = orderItemToRemoveValue.itemPackage
      const itemPackageOrderItems = removableItemPackageOrderItems(orderItemToRemoveValue)

      if (!_.isEmpty(itemPackageOrderItems)) {
        order.orderItems.removeAll(itemPackageOrderItems)
        removeOrderItemPackageDiscounts(order, itemPackage)
        return true
      }
    } else {
      order.orderItems.remove(orderItemToRemoveValue)
      return true
    }

    return false
  }

  function removableItemPackageOrderItems (orderItemToRemove) {
    const order = orderItemToRemove.order

    const user = orderItemToRemove.ticket?.user || orderItemToRemove.itemOrderItem?.user || orderItemToRemove.activityTicket?.user
    let showing = orderItemToRemove.ticket?.showing
    const activityBookingId = orderItemToRemove.activityTicket?.activityBookingId || orderItemToRemove.itemOrderItem?.activityBookingId
    const itemPackageOrderItems = []

    for (const itemPackageItem of orderItemToRemove.itemPackage.itemPackageItems.data) {
      let foundItemPackageOrderItem = null

      if (!_.isNil(itemPackageItem.itemVariation)) {
        foundItemPackageOrderItem = _.findLast(order.draftOrderItems, (orderItem) => {
          if (orderItem.state !== ORDER_ITEM_STATES.DRAFT) return false
          if (orderItem.itemPackageId !== orderItemToRemove.itemPackageId) return false
          if (orderItem.itemOrderItem?.itemVariationId !== itemPackageItem.itemVariationId) return false
          if (orderItem.itemOrderItem?.activityBookingId !== activityBookingId) return false
          if (orderItem.itemOrderItem?.user?.id !== user?.id) return false
          if (_.includes(itemPackageOrderItems, orderItem)) return false

          return true
        })
      } else if (!_.isNil(itemPackageItem.ticketType)) {
        foundItemPackageOrderItem = _.findLast(order.draftOrderItems, (orderItem) => {
          if (orderItem.state !== ORDER_ITEM_STATES.DRAFT) return false
          if (orderItem.itemPackageId !== orderItemToRemove.itemPackageId) return false

          if (_.isNil(activityBookingId)) {
            if (orderItem.ticket?.ticketTypeId !== itemPackageItem.ticketTypeId) return false
            if (orderItem.ticket?.user?.id !== user?.id) return false

            showing ||= orderItem.ticket?.showing
            if (orderItem.ticket?.showing?.id !== showing.id) return false
          } else {
            if (orderItem.activityTicket?.ticketTypeId !== itemPackageItem.ticketTypeId) return false
            if (orderItem.activityTicket?.activityBookingId !== activityBookingId) return false
            if (orderItem.activityTicket?.user?.id !== user?.id) return false
          }

          if (_.includes(itemPackageOrderItems, orderItem)) return false

          return true
        })
      }

      if (_.isNil(foundItemPackageOrderItem)) return []

      itemPackageOrderItems.push(foundItemPackageOrderItem)
    }

    return itemPackageOrderItems
  }

  function removeOrderItemPackageDiscounts (order, itemPackage) {
    const hasFoundItemPackageById = {}
    const foundItemPackageDiscounts = []

    for (const orderItem of order.unpaidOrderItems) {
      if (_.isNil(orderItem.itemPackageId)) continue
      if (orderItem.paid) continue

      if (orderItem.itemPackageId === itemPackage.id) return

      if (hasFoundItemPackageById[orderItem.itemPackageId] === true) continue

      hasFoundItemPackageById[orderItem.itemPackageId] = true
      _.concat(foundItemPackageDiscounts, orderItem.itemPackage.discountsForOrder)
    }

    const removableItemPackageDiscounts = _.difference(itemPackage.discountsForOrder, foundItemPackageDiscounts)
    const remainingRemovableItemPackageDiscounts = _.difference(order.independentDiscounts.data, removableItemPackageDiscounts)
    order.independentDiscounts.removeAll(remainingRemovableItemPackageDiscounts)
  }

  return {
    removeOrderItem
  }
}
